import React, { useEffect } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { blackGrayAuthorPlaceholder } from '../../constants/placeholder';
import {
  blackGrayAuthorOptions,
  blackGrayAuthorToApiValue,
} from './constants';
import { commonBackInfo } from '../../utils';
import './index.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function BlackGrayAuthorSelect({
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatOptionsMessage } = useLanguage();
  const {
    selects: value,
    setSelects: setValue,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'black_gray_author_filter',
    options: blackGrayAuthorOptions.map((item) => item.value),
  });
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'black_gray_author_filter',
      commonBackInfo(
        { black_gray_author_filter: blackGrayAuthorToApiValue(value) },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [value]);

  return (
    <div className={`dbo-black-gray-author-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={blackGrayAuthorPlaceholder[lang]}
        onClear={() => setValue([])}
        selectOptionsInfo={[value, setValue]}
        options={formatOptionsMessage(blackGrayAuthorOptions)}
        pointKey={FilterButtonPoint.blackGrayAuthor}
      ></CustomSelect>
    </div>
  );
}
